import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// PROTECTED ROUTE IMPORT
import RouteGuard from "./RouteGuard";

// MODULE ROUTE IMPORTS
import authRoute from "./auth.route";
import defaultRoute from "./default.route";
import productRoute from "./product.route";
import customerRoute from "./customer.route";
import accountRoute from "./account.route";
import glAccountingRoute from "./glAccounting.route";
import systemAdminRoute from "./systemAdmin.route";
import groupRoute from "./group.route";
import securityRoute from "./security.route";
import operationsRoute from "./operations.route";
import configurations from "./configurations.route";
import treasuryRoute from "./treasury.route";
import contractBookingRoute from "./contractbooking.route";
import tellerRoute from "./teller.route";
import reportsRoute from "./reports.route";
import FAQ from "./FAQ.route";
import walletRoute from "./wallet.route";
import { BOM } from "../services/definedMethod";
import moduleRouteMapping from "./moduleRouteMapping";

const routeCollections = {
  authRoute,
  defaultRoute,
  productRoute,
  customerRoute,
  accountRoute,
  glAccountingRoute,
  systemAdminRoute,
  groupRoute,
  securityRoute,
  operationsRoute,
  configurations,
  treasuryRoute,
  contractBookingRoute,
  tellerRoute,
  reportsRoute,
  FAQ,
  walletRoute,
};

const RouteRenderer = () => {
  const getFilteredRoutes = () => {
    const allRoutes = [];
    Object.entries(routeCollections).forEach(([routeFile, routes]) => {
      // Get the required module for this route file
      const requiredModule = moduleRouteMapping[routeFile];

      // If requiredModule is null, BOM returns true (no check needed)
      const isAllowed = BOM.IsModuleLicensed(requiredModule);

      // If allowed, add all routes from this file to the filtered routes
      if (isAllowed && Array.isArray(routes)) {
        allRoutes.push(...routes);
      }
    });

    return allRoutes;
  };

  const filteredRoutes = getFilteredRoutes();

  return (
    <BrowserRouter>
      <Routes>
        {filteredRoutes.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={
              item.isProtected ? (
                <RouteGuard component={item.component} />
              ) : (
                <item.component />
              )
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default RouteRenderer;
